export default __webpack_public_path__ + "static/media/ci-logo-trans.cb22597c.svg";